import React from 'react';
import {Button, Checkbox, Descriptions, Input, message, Modal, Space} from "antd";
import {connect} from "react-redux";
import {
    createCompanyWebhook,
    editCompanyWebhook,
    loadCompanyWebhook,
    loadCompanyWebhookEventTypes
} from "../../actions/account";
import {displayErrors} from "../../libs/utils";
import WebhookSecret from "./WebhookSecret";

class WebhookModal extends React.Component
{
    state = {
        loadingWebhook: false,
        webhookLoaded: false,
        loadingWebhookEvenTypes: false,
        webhookEvenTypesLoaded: false,

        availableEventTypes: [],

        name: '',
        endpointUrl: '',
        eventTypes: [],
        secret: null,

        creatingWebhook: false,
        editingWebhook: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.state.webhookEvenTypesLoaded && this.props.showModal && !this.state.loadingWebhookEvenTypes) {
            this.setState({ loadingWebhookEvenTypes: true}, () => {
                this.props.loadCompanyWebhookEventTypes(this.props.companyGuid, (res) => {
                    this.setState({ availableEventTypes: res.data, webhookEvenTypesLoaded: true, loadingWebhookEvenTypes: false});
                }, (err) => {
                    if(typeof err.response !== 'undefined') {
                        this.setState({ webhookEvenTypesLoaded: true, loadingWebhookEvenTypes: false});
                        displayErrors(err.response.data);
                    }
                });
            });
        }

        if(this.props.webhookId && !this.state.webhookLoaded && this.props.showModal && !this.state.loadingWebhook) {
            this.setState({ loadingWebhook: true}, () => {
                this.loadWebhook()
            });
        }
    }

    loadWebhook() {
        this.props.loadCompanyWebhook(this.props.companyGuid, this.props.webhookId, (res) => {

            this.setState({
                webhookLoaded: true,
                loadingWebhook: false,

                name: res.data.name,
                endpointUrl: res.data.url,
                eventTypes: res.data.events,
                secret: res.data.secret,
            });

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ webhookLoaded: true, loadingWebhook: false});
                displayErrors(err.response.data);
            }
        });
    }

    closeModal(reload = false) {
        this.setState({
            loadingWebhook: false,
            webhookLoaded: false,
            loadingWebhookEvenTypes: false,
            webhookEvenTypesLoaded: false,

            availableEventTypes: [],

            name: '',
            endpointUrl: '',
            eventTypes: []
        });
        this.props.close(reload)
    }

    updateSelectedEventTypes(key, value) {
        let newEventTypes = [...this.state.eventTypes];

        if(value) {
            newEventTypes.push(key);
        } else {
            newEventTypes = newEventTypes.filter(item => item !== key);
        }

        this.setState({ eventTypes: newEventTypes });
    }

    createWebhook() {
        if(this.state.name.trim().length === 0) {
            return message.error('Please enter a name for the webhook!');
        }

        if(this.state.endpointUrl.trim().length === 0) {
            return message.error('Please enter the endpoint URL!');
        }

        if(this.state.eventTypes.length === 0) {
            return message.error('Please select at least one event type!');
        }

        let data = {
            name: this.state.name,
            endpoint_url: this.state.endpointUrl,
            event_types: this.state.eventTypes
        };

        this.setState({ creatingWebhook: true });

        this.props.createCompanyWebhook(this.props.companyGuid, data, () => {
            this.setState({ creatingWebhook: false });
            message.success('Webhook successfully created!')
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                this.setState({ creatingWebhook: false });
                displayErrors(err.response.data);
            }
        })
    }

    editWebhook() {
        if(this.state.name.trim().length === 0) {
            return message.error('Please enter a name for the webhook!');
        }

        if(this.state.endpointUrl.trim().length === 0) {
            return message.error('Please enter the endpoint URL!');
        }

        if(this.state.eventTypes.length === 0) {
            return message.error('Please select at least one event type!');
        }

        let data = {
            name: this.state.name,
            endpoint_url: this.state.endpointUrl,
            event_types: this.state.eventTypes
        };

        this.setState({ editingWebhook: true });

        this.props.editCompanyWebhook(this.props.companyGuid, this.props.webhookId, data, () => {
            this.setState({ editingWebhook: false });
            message.success('Webhook successfully updated!')
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                this.setState({ editingWebhook: false });
                displayErrors(err.response.data);
            }
        })
    }

    render() {
        return (
            <Modal
                centered
                title={this.props.webhookId ? 'View Webhook' : 'Create Webhook'}
                open={this.props.showModal}
                width={700}
                onCancel={() => this.closeModal()}
                footer={<Space>
                    <Button onClick={() => this.closeModal()}>Close</Button>
                    {this.props.webhookId ? <Button type='primary' loading={this.state.editingWebhook} disabled={this.state.editingWebhook} onClick={() => this.editWebhook()}>Update</Button> : <Button type='primary' loading={this.state.creatingWebhook} disabled={this.state.creatingWebhook} onClick={() => this.createWebhook()}>Create</Button>}
                </Space>}
                destroyOnClose={true}>

                <Descriptions bordered size='small' layout='horizontal' column={1}>
                    <Descriptions.Item label='Name' labelStyle={{width: '30%'}}>
                        <Input value={this.state.name} onChange={(e) => {
                            this.setState({ name: e.target.value })
                        }} />
                    </Descriptions.Item>
                    <Descriptions.Item label='Endpoint URL' labelStyle={{width: '30%'}}>
                        <Input value={this.state.endpointUrl} onChange={(e) => {
                            this.setState({ endpointUrl: e.target.value })
                        }} />
                    </Descriptions.Item>
                    {this.state.secret !== null ? <Descriptions.Item label='Secret' labelStyle={{width: '30%'}}>
                        <WebhookSecret webhookId={this.props.webhookId} secret={this.state.secret} reload={() => this.loadWebhook()}/>
                    </Descriptions.Item> : null}
                    <Descriptions.Item label='Event types' labelStyle={{width: '30%'}}>
                        {this.state.availableEventTypes.map(item => {
                            return <Checkbox key={item.key} checked={this.state.eventTypes.includes(item.key)} onChange={(e) => this.updateSelectedEventTypes(item.key, e.target.checked) }>{item.key}</Checkbox>
                        })}
                    </Descriptions.Item>
                </Descriptions>
            </Modal>
        )
    }
}

export default connect(null, { loadCompanyWebhook, loadCompanyWebhookEventTypes, createCompanyWebhook, editCompanyWebhook })(WebhookModal);